import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaMoon, FaSun, FaLanguage, FaUserShield, FaCheck } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import BottomNav from '../components/public/BottomNav';
import SideMenu from '../components/public/SideMenu';
import LanguageSelector from '../components/public/LanguageSelector';
import { languageService } from '../services/languageService';
import logo from '../assets/logo.svg';
import './LanguagesPage.css';
import './Home.css';

const LanguagesPage = () => {
  const { t, i18n } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const { setShowLanguageModal } = useLanguage();
  const { isAuthenticated, logout } = useAuth();
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedLang, setSelectedLang] = useState(i18n.language);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLanguages();
  }, []);

  const fetchLanguages = async () => {
    try {
      const response = await languageService.getLanguages();
      setLanguages(response.data);
    } catch (error) {
      console.error('Error fetching languages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLanguageChange = (langCode) => {
    setSelectedLang(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  return (
    <div className="home-page">
      <header className="app-header">
        <div className="header-container">
          <img src={logo} alt="Indian Festival Calendar" className="app-logo" />
          <div className="header-actions">
            <button
              className="icon-btn"
              onClick={() => navigate('/languages')}
              title={t('select_language')}
            >
              <FaLanguage />
            </button>
            <button
              className="icon-btn"
              onClick={toggleTheme}
              title={t('theme')}
            >
              {theme === 'light' ? <FaMoon /> : <FaSun />}
            </button>
            {isAuthenticated ? (
              <div className="user-menu">
                <Link to="/admin" className="btn btn-primary">
                  <FaUserShield /> Admin
                </Link>
                <button className="btn btn-outline" onClick={logout}>
                  {t('logout')}
                </button>
              </div>
            ) : (
              <Link to="/imcloginforadmin" className="btn btn-primary">
                {t('login')}
              </Link>
            )}
          </div>
          <button
            className="hamburger-btn"
            onClick={() => setShowSideMenu(true)}
          >
            <FaBars />
          </button>
        </div>
      </header>

      <div className="languages-container">
        <div className="languages-card">
          <div className="languages-header">
            <h2>Select Language</h2>
            <p>Choose your preferred language</p>
          </div>

          {loading ? (
            <div className="loading">Loading languages...</div>
          ) : (
            <div className="languages-list">
              {languages.map((language) => (
                <button
                  key={language.code}
                  className={`language-item ${selectedLang === language.code ? 'active' : ''}`}
                  onClick={() => handleLanguageChange(language.code)}
                >
                  <div className="language-info">
                    <div className="language-name">{language.name}</div>
                    <div className="language-native">{language.nativeName}</div>
                  </div>
                  {selectedLang === language.code && (
                    <div className="check-icon">
                      <FaCheck />
                    </div>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <BottomNav activeTab="language" />
      <SideMenu isOpen={showSideMenu} onClose={() => setShowSideMenu(false)} />
      <LanguageSelector />
    </div>
  );
};

export default LanguagesPage;
